export const COURT_APPEAL_DOC_ID = '001';
export const CIVIL_MECHANICAL_EXPERTISE_DOC_ID = '002';
export const CIVIL_MEDICAL_EXPERTISE_DOC_ID = '003';
export interface JudgementCivilDoc {
  url: string;
  type: string;
  name: string;
}
export const ACCORDION = {
  MEDICAL: 'medical',
  ACCOUNTING: 'accounting',
  MECHANICAL: 'mechanical',
} as const;

export const ACCORDION_STATE = {
  [ACCORDION.MEDICAL]: true,
  [ACCORDION.ACCOUNTING]: true,
  [ACCORDION.MECHANICAL]: true,
};
export const CURRENT_INDEX_STATE = {
  [ACCORDION.MEDICAL]: 0,
  [ACCORDION.ACCOUNTING]: 0,
  [ACCORDION.MECHANICAL]: 0,
};
export const CORRECTIONNEL_JUDGEMENT = 'jom.cj';
export const CIVIL_JUDGEMENT = 'jom.civjs';
export const APPEAL_JUDGEMENT = 'APPEAL_JUDGEMENT';
